import React from "react"
import moment from 'moment'
import { connect } from "react-redux"

import { commonErr } from "../common/errors"
import { CarTransmission, formatPrice } from "../common/common"
import { LoadingInline } from "../common/loading"

import ConfirmBooking from "./confirmbooking"


class CarGroupItem extends React.Component {

	render() {
		const { car, filter } = this.props
		const isWithDriver = filter.stype === 2
	
		return <div className={`item-car-group ${!car.avail && car.id === "" ? "disabled" : ""}`} key={car.id} onClick={() => this.props.togglePopup(car.id)}> 
									<h5 className="font-bold">
										{car.groupName}
										{!car.avail && <span className="ml-1 badge badge-primary">Sold out</span>}
									</h5>
									<div className="d-flex"> 
										<div className="left"> 
											<div className="fix-img"><img src={car.avatarUrl} alt={car.groupName} /></div>
										</div>
										<div className="right"> 
											<p className="price">Giá: <span className="font-weight-bold">{formatPrice(car.carGroupPrice)}</span> <span>{isWithDriver ? "/chuyến": ""}</span></p>
											<p>{car.groupDesc}</p>
											<p>
												{/* <span className="badge badge-primary mr-2">{filter.vehicleType}</span> */}
												<span className="badge badge-warning">{CarTransmission[filter.transmission]}</span>
											</p>
										</div>
									</div>
						</div>
	}
}

class ListView extends React.Component {
	
	render() {
		const searchData = this.props.carFinding;
		const filter = searchData.filter;
		const { platformType, startDate, endDate, stype } = this.props;
		const allowPlatformBooking = searchData.allowPlatformBooking;


		if (searchData.err === commonErr.INNIT || searchData.err === commonErr.LOADING) {
			return <LoadingInline />
		} else {
			return <div className="ibox">
						<div className="ibox-body">
							<div className="result-searching__wrapper">
								{searchData.carGroups && searchData.carGroups.map(car => 
									<div className="result-searching__item" key={car.groupName}>
										<CarGroupItem car={car} filter={filter} togglePopup={this.props.togglePopup} />
									</div>
								)}                                                                                                                                     
							</div>
							<ConfirmBooking wd={searchData.wd} platformType={platformType} startDate={startDate} endDate={endDate} stype={stype} filter={filter} cars={searchData.carGroups} show={this.props.show} onHide={this.props.hideConfirm} popupId={this.props.popupId} allowPlatformBooking={allowPlatformBooking} />
					</div>
				</div>
		 }
	}
}

function mapState(state) {
	return {
			carFinding: state.carFinding
	}
}

ListView = connect(mapState)(ListView);

export default ListView;




// WEBPACK FOOTER //
// ./src/components/car/listview.js